module.exports = __webpack_public_path__ + "media/images/pro_subscription/partnership/v2/partenariat3@3x-b967a3051024700b1f2de48efae6f796.jpg";